import { createGlobalState } from '@vueuse/core'
import { useCookies } from '@vueuse/integrations/useCookies'
import { ref } from 'vue'
export const useStore = createGlobalState(() => {
  // state
  const locationId = ref('')
  const storeId = ref('')
  const companyId = ref('')
  const isLogin = ref(false)
  const token = ref('')
  const storeName = ref('')
  const user = ref({
    name: '',
    email: '',
  })
  const productDetailPath = ref('')
  const apiBaseUrl = ref('')
  const cookies = useCookies()

  const logout = () => {
    cookies.remove(`token_${storeId.value}`, {
      path: '/',
    })
    // Holds the customer's email, and the storefront reads it for checkout prefill.
    localStorage.removeItem(`user_${storeId.value}`)

    isLogin.value = true
    token.value = ''

    user.value = {
      name: '',
      email: '',
    }
  }

  return { locationId, storeId, companyId, isLogin, token, storeName, user, productDetailPath, apiBaseUrl, logout }
})
